import * as React from "react"
import {graphql, PageProps} from "gatsby"
import WebsiteLayout from "@layouts/WebsiteLayout"
import Seo from "@components/shared/Seo"
import components from "@components/strapi"
import {PageContextProps} from "../types"
import {SidebarItem} from "@layouts/WebsiteLayout/props";

const PageTemplate: React.FC<PageProps<Queries.pageQuery, PageContextProps>> = ({
    data,
    location,
    pageContext,
}) => {
    const {strapiPage: page} = data
    const sections = page?.sections
    const seo = page?.seo
    const articleHero = page?.article_hero
    const sidebar = page?.sidebar

    return <WebsiteLayout
        articleHero={articleHero}
        sidebar={sidebar}
    >
        <Seo
            title={seo?.meta_title || page?.title}
            description={seo?.meta_description}
            index={seo?.index}
            image={seo?.meta_image as Queries.StrapiUploadFile}
            location={location}
            frontPage={!!pageContext?.frontPage}
        />
        {sections && sections.map((section) => {
            const Component = components[`${section?.__typename}`]
            const componentProps = {...section, location}
            return <React.Fragment key={section?.__typename}>
                {Component
                 ? <Component {...componentProps} />
                 : <>{process.env.NODE_ENV !== "production" ? <p>Missing section {section?.__typename}</p> : ""}</>}
            </React.Fragment>
        })}
    </WebsiteLayout>
}

export default PageTemplate

export const pageQuery = graphql`
    query page($id: String!)
    {
        strapiPage(id:{eq: $id}) {
            title
            slug
            seo {
                ...Seo
            }
            article_hero {
                title
                image {
                    alternativeText
                    file {
                        childImageSharp {
                            gatsbyImageData(
                                height: 320
                                layout: CONSTRAINED
                            )
                        }
                    }
                }
            }
            sidebar {
                items {
                    title
                    anchor_element_id
                }
            }
            sections {
                ...Hero
                ...HeroV2
                ...Highlights
                ...AverageSavings
                ...SavingsBlock
                ...Reviews
                ...PartnerBlock
                ...WozResearchBlock
                ...Faq
                ...BottomWozCheck
                ...ArticleSavings
                ...AnchorElement
                ...PlainContent
                ...ArticleContactDetails
                ...ContactForm
                ...ArticlePartnerList
                ...RepeatableComponent
                ...InlineFaq
                ...VacancyList
                ...CookieSettings
                ...InlineWozCheckBox
                ...YearlyWozResearch
                ...ProcessAndHighlights
            }
        }
    }
`
